import { useFormik } from 'formik';
import { useEffect } from 'react';
import { LegalProceeding } from '../../../../../../shared/types/legalProceedings/legalProceedings';
import dayjs from 'dayjs';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const useLegalProceedingsProcessData = (
    legalProceeding?: LegalProceeding
) => {
    const formik = useFormik({
        initialValues: {
            dateReceipt: null as dayjs.Dayjs | null,
            registeredCompany: '',
            documentClaimant: '',
            nameClaimant: '',
            documentProcessed: '',
            nameProcessed: '',
            insuredDocument: '',
            insuredName: '',
            requirementNumber: '',
            fileNumber: '',
            namePersonSubscribe: '',
            policy: '',
            senderEmail: '',
            plate: '',
            expirationDate: null as dayjs.Dayjs | null,
            legalProceedings: '',
            pqrIdentified: '',
            submittingEntity: '',
            address: '',
            subject: '',
            location: '',
            bouquet: '',
            detail: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            dateReceipt:
                dayjs(legalProceeding?.processData?.dateReceipt).subtract(
                    5,
                    'hours'
                ) || null,
            registeredCompany:
                legalProceeding?.processData?.registeredCompany || '',
            documentClaimant:
                legalProceeding?.processData?.documentClaimant || '',
            nameClaimant: legalProceeding?.processData?.nameClaimant || '',
            documentProcessed:
                legalProceeding?.processData?.documentProcessed || '',
            nameProcessed: legalProceeding?.processData?.nameProcessed || '',
            insuredDocument:
                legalProceeding?.processData?.insuredDocument || '',
            insuredName: legalProceeding?.processData?.insuredName || '',
            requirementNumber:
                legalProceeding?.processData?.requirementNumber || '',
            fileNumber: legalProceeding?.processData?.requirementNumber || '',
            namePersonSubscribe:
                legalProceeding?.processData?.namePersonSubscribe || '',
            policy: legalProceeding?.processData?.policy || '',
            senderEmail: legalProceeding?.processData?.senderEmail || '',
            plate: legalProceeding?.processData?.plate || '',
            expirationDate:
                dayjs(legalProceeding?.processData?.expirationDate).subtract(
                    5,
                    'hours'
                ) || null,
            legalProceedings: useGetNameOrValue(
                legalProceeding?.processData?.legalProceedings || ''
            ),
            pqrIdentified: legalProceeding?.processData?.pqrIdentified || '',
            submittingEntity: useGetNameOrValue(
                legalProceeding?.processData?.submittingEntity || ''
            ),
            address: legalProceeding?.processData?.address || '',
            subject: useGetNameOrValue(
                legalProceeding?.processData?.subject || ''
            ),
            location: useGetNameOrValue(
                legalProceeding?.processData?.location || ''
            ),
            bouquet: useGetNameOrValue(legalProceeding?.product?.bouquet || ''),
            detail: legalProceeding?.processData?.detail || '',
        });
    }, [legalProceeding]);

    return {
        formik,
    };
};
